import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperMapLocations() {
    const selector = ".swiper-map-locations";
    const element = document.querySelector(selector);
    
    if (!element) return;

    const slideCount = element.querySelectorAll('.swiper-slide').length;
    const maxSlidesPerView = 3; // Based on max breakpoint

    new Swiper(selector, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.3,
        spaceBetween: 16,
        centeredSlides: true,
        speed: 600,
        
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
                centeredSlides: false,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 24,
            }
        }
    });
}
